import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./performers.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
const Performers = ({ logout, user, API_URL }) => {
    const [selectorType, setselectorType] = useState("");
    const [driver4x4, setDriver4x4] = useState([]);
    const [driver4x4Other, setDriver4x4Other] = useState([]);
    const [guide, setGuide] = useState([]);
    const [cafe, setCafe] = useState([]);
    const [driverSedan, setDriverSedan] = useState([]);
    const [driverBus, setDriverBus] = useState([]);
    const [monthTours, setMonthTours] = useState([]);
    const [badDays, setBadDays] = useState([]);
    const [modalTours, setModalTours] = useState([]);
    const [selectedTourValue, setSelectedTourValue] = useState("");
    const [cafeCount, setCafeCount] = useState(0);
    const [modal, setModal] = useState({
        open: false,
        name: "",
        weekday: "",
        day: "",
        monthName: ""
    });

    const [currentDate, setCurrentDate] = useState(new Date());

    const months = [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
    ];

    const weekDays = [
        "Вс",
        "Пн",
        "Вт",
        "Ср",
        "Чт",
        "Пт",
        "Сб",
    ];
    const LANG_LABELS = {
        eng: "Английский",
        rus: "Русский",
        uz: "Узбекский",
        itl: "Итальянский",
        fra: "Французский",
        deu: "Немецкий",
        spa: "Испанский",
        tur: "Турецкий",
        chn: "Китайский",
        jpn: "Японский",
        kor: "Корейский",
        ara: "Арабский",
        hin: "Хинди",
        per: "Персидский",
        kaz: "Казахский",
        taj: "Таджикский",
    };

    const monthName = months[currentDate.getMonth()];
    const year = currentDate.getFullYear();

    const daysInMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
    ).getDate();

    const days = Array.from(
        { length: daysInMonth },
        (_, i) => i + 1
    );

    const prevMonth = () => {
        const date = new Date(currentDate);
        date.setMonth(date.getMonth() - 1);
        setCurrentDate(date);
    };

    const nextMonth = () => {
        const date = new Date(currentDate);
        date.setMonth(date.getMonth() + 1);
        setCurrentDate(date);
    };

    const getWeekDay = (day) => {
        return weekDays[
            new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                day
            ).getDay()
        ];
    };



    const getDriver4x4 = async () => {
        const res = await axios.post(`${API_URL}/getDriver4x4`);
        setDriver4x4(res.data);
    }
    const getDriver4x4Other = async () => {
        const res = await axios.post(`${API_URL}/getDriver4x4Other`);
        setDriver4x4Other(res.data);
    }
    const getGuide = async () => {
        const res = await axios.post(`${API_URL}/getGuide`);
        setGuide(res.data);
    }
    const getCafe = async () => {
        const res = await axios.post(`${API_URL}/getCafe`);
        setCafe(res.data);
    }
    const getDriverSedan = async () => {
        const res = await axios.post(`${API_URL}/getDriverSedan`);
        setDriverSedan(res.data);
    }
    const getDriverBus = async () => {
        const res = await axios.post(`${API_URL}/getDriverBus`);
        setDriverBus(res.data);
    }
    useEffect(() => {
        if (!user) return;

        if (user.role === "admin" || user.role === "mechanic") {
            setselectorType("4x4");
        } else if (user.subroles?.includes("sedan")) {
            setselectorType("sedan");
        } else if (user.subroles?.includes("guide")) {
            setselectorType("guide");
        } else if (user.subroles?.includes("bus")) {
            setselectorType("bus");
        } else if (user.subroles?.includes("lunch")) {
            setselectorType("cafe");
        }
    }, [user]);
    useEffect(() => {
        getDriver4x4();
        getDriver4x4Other();
        getGuide();
        getCafe();
        getDriverSedan();
        getDriverBus();
    }, []);
    let performers = [];

    switch (selectorType) {
        case "4x4":
            performers = [...driver4x4, ...driver4x4Other];
            break;

        case "guide":
            performers = guide;
            break;

        case "sedan":
            performers = driverSedan;
            break;

        case "bus":
            performers = driverBus;
            break;

        case "cafe":
            performers = cafe;
            break;

        default:
            performers = [];
    }
    const modalWindow = async (performer, day) => {
        const ds = dateStr(day);
        const isMulti = selectorType === "sedan" || selectorType === "bus" || selectorType === "cafe";
        const dayTours = getAssignedToursForDay(performer.name, day);

        if (isMulti) {
            const ongoing = dayTours.filter((t) => t.dateStart !== ds); // уже в пути, не редактируется отсюда
            setSelectedTourValue(""); // ← добавить эту строку
            setCafeCount(0);
            setModal({
                open: true,
                name: performer.name,
                weekday: getWeekDay(day),
                day,
                monthName,
                date: ds,
                multi: true,
                readOnly: false,
                ongoing,
            });

            try {
                const res = await axios.post(`${API_URL}/getCellInfo`, {
                    selectorType,
                    performerName: performer.name,
                    date: ds,
                });
                setModalTours(res.data.tours || []);
            } catch (err) {
                console.error("Ошибка загрузки данных ячейки:", err);
                setModalTours([]);
            }
            return;
        }

        // ── старое поведение для 4x4 / guide / cafe без изменений ──
        const assigned = dayTours[0];

        if (assigned && assigned.dateStart !== ds) {
            setModal({
                open: true,
                name: performer.name,
                weekday: getWeekDay(day),
                day,
                monthName,
                date: ds,
                multi: false,
                readOnly: true,
                readOnlyInfo: assigned,
            });
            return;
        }

        setModal({
            open: true,
            name: performer.name,
            weekday: getWeekDay(day),
            day,
            monthName,
            date: ds,
            multi: false,
            readOnly: false,
        });

        try {
            const res = await axios.post(`${API_URL}/getCellInfo`, {
                selectorType,
                performerName: performer.name,
                date: ds,
            });
            setModalTours(res.data.tours || []);
            setSelectedTourValue(
                res.data.current ? `${res.data.current.orderNumber}|${res.data.current.requestType}` : ""
            );
            if (selectorType === "cafe") {
                setCafeCount(res.data.current ? res.data.current.ownCount : 0);
            }
        } catch (err) {
            console.error("Ошибка загрузки данных ячейки:", err);
            setModalTours([]);
            setSelectedTourValue("");
            setCafeCount(0);
        }
    };

    const pad2 = (n) => String(n).padStart(2, "0");
    const dateStr = (day) =>
        `${currentDate.getFullYear()}-${pad2(currentDate.getMonth() + 1)}-${pad2(day)}`;

    // const getAssignedTour = (performerName, day) => {
    //     const ds = dateStr(day);
    //     return monthTours.find((t) => {
    //         if (!t.assignedNames.includes(performerName)) return false;
    //         if (selectorType === "cafe") {
    //             return t.dateStart === ds; // кафе — только день старта, без диапазона
    //         }
    //         return t.dateStart <= ds && t.dateEnd >= ds; // машины/гид — весь диапазон тура
    //     });
    // };
    const getAssignedToursForDay = (performerName, day) => {
        const ds = dateStr(day);
        return monthTours.filter((t) => {
            if (!t.assignedNames?.includes(performerName)) return false;
            if (selectorType === "cafe") return t.dateStart === ds;
            return t.dateStart <= ds && t.dateEnd >= ds;
        });
    };
    // Микро/автобус: показываем, сколько человек в заказе
    const paxLabel = (t) => (selectorType === "bus" && t.participants ? ` — ${t.participants} чел.` : "");
    const isBadDay = (day) => badDays.includes(day);

    // ─── Потребность по дням для шапки: "назначено / нужно" ───────
    // Машины и гид — все туры, которые идут в этот день (весь период тура, как в ячейках),
    //   нужно = сколько машин/гидов заказано в туре (neededCount).
    // Кафе — туры, которые начинаются в этот день, нужно = количество человек.
    // Отменённые туры не считаются. Лишние назначения сверх нужного не учитываются,
    // чтобы перебор в одном туре не "закрывал" нехватку в другом.
    const dayNeeds = useMemo(() => {
        const map = {};
        for (const day of days) {
            const ds = dateStr(day);
            let needed = 0;
            let assigned = 0;
            for (const t of monthTours) {
                if (t.isCancelled) continue;
                if (selectorType === "cafe") {
                    if (t.dateStart !== ds) continue;
                    const total = Number(t.total) || 0;
                    needed += total;
                    assigned += Math.min(Number(t.assignedTotal) || 0, total);
                } else {
                    if (t.dateStart !== ds) continue; // считаем только в день начала тура
                    const need = Number(t.neededCount) || 0;
                    needed += need;
                    assigned += Math.min(t.assignedNames?.length || 0, need);
                }
            }
            map[day] = { needed, assigned };
        }
        return map;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthTours, selectorType, currentDate]);

    const refreshMonthData = async () => {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        try {
            const [assignRes, coverRes] = await Promise.all([
                axios.post(`${API_URL}/getMonthAssignments`, { selectorType, year, month }),
                axios.post(`${API_URL}/getMonthCoverage`, { selectorType, year, month }),
            ]);
            setMonthTours(assignRes.data.tours || []);
            setBadDays(coverRes.data.badDays || []);
        } catch (err) {
            console.error("Ошибка загрузки занятости:", err);
        }
    };
    useEffect(() => {
        setModalTours([]);
        setSelectedTourValue("");
        setCafeCount(0);
        setModal({ open: false, name: "", weekday: "", day: "", monthName: "" });
    }, [selectorType]);
    useEffect(() => {
        refreshMonthData();
    }, [selectorType, currentDate]);

    // ─── Realtime: обновление при действиях других операторов ───
    useEffect(() => {
        const socketUrl = API_URL.replace(/\/api\/?$/, "");
        const socket = io(socketUrl);

        socket.on("calendar:update", () => {
            refreshMonthData();

            // если открыта модалка на ячейке — обновим и её данные тоже
            if (modal.open && !modal.readOnly) {
                axios.post(`${API_URL}/getCellInfo`, {
                    selectorType,
                    performerName: modal.name,
                    date: modal.date,
                }).then((res) => {
                    setModalTours(res.data.tours || []);
                }).catch((err) => console.error("Ошибка обновления ячейки:", err));
            }
        });

        return () => socket.disconnect();
    }, [API_URL, selectorType, modal.open, modal.name, modal.date, modal.readOnly]);
    return (
        <div className="performers">
            <div className="performers-flex">
                <div className="performers-section1">
                    <div className="performers-section1-text">
                        Таблица <br />Занятости
                    </div>
                    <div className="performers-section1-selector">
                        {(user?.role === "admin" || user?.role === "mechanic") && (
                            <button className={`performers-section1-selector-button ${selectorType === "4x4" ? "active" : ""}`} onClick={() => { setselectorType("4x4") }}><i class="fa-solid fa-truck-monster"></i>4x4</button>
                        )}
                        {(user?.role === "admin" || user?.subroles?.includes("sedan")) && (
                            <button className={`performers-section1-selector-button ${selectorType === "sedan" ? "active" : ""}`} onClick={() => { setselectorType("sedan") }}><i class="fa-solid fa-car"></i>Седан</button>
                        )}
                        {(user?.role === "admin" || user?.subroles?.includes("guide")) && (
                            <button className={`performers-section1-selector-button ${selectorType === "guide" ? "active" : ""}`} onClick={() => { setselectorType("guide") }}><i class="fa-solid fa-user"></i>Гид</button>
                        )}
                        {(user?.role === "admin" || user?.subroles?.includes("bus")) && (
                            <button className={`performers-section1-selector-button ${selectorType === "bus" ? "active" : ""}`} onClick={() => { setselectorType("bus") }}><i class="fa-solid fa-bus-simple"></i>Микро/автобус</button>
                        )}
                        {(user?.role === "admin" || user?.subroles?.includes("lunch")) && (
                            <button className={`performers-section1-selector-button ${selectorType === "cafe" ? "active" : ""}`} onClick={() => { setselectorType("cafe") }}><i class="fa-solid fa-mug-saucer"></i>Кафе</button>
                        )}
                    </div>
                    <div className="performers-section1-dateselect">

                        <button
                            className="month-btn"
                            onClick={prevMonth}
                        >
                            <i class="fa-solid fa-angle-left"></i>
                        </button>

                        <span className="month-title">
                            {monthName} {year}
                        </span>

                        <button
                            className="month-btn"
                            onClick={nextMonth}
                        >
                            <i class="fa-solid fa-angle-right"></i>
                        </button>

                    </div>
                </div>
                <div className="performers-section2">
                    <table className="performers-table">
                        <thead>
                            <tr>
                                <th className="sticky-column performer-modelname">Имя / Модель</th>
                                {days.map((day) => (
                                    <th key={day} className={`${isBadDay(day) ? "bad-day" : ""}`}>
                                        <div className="day">{day}</div>
                                        <div className="weekday">{getWeekDay(day)}</div>
                                        {dayNeeds[day]?.needed > 0 && (
                                            <div
                                                className={`day-need ${dayNeeds[day].assigned >= dayNeeds[day].needed ? "day-need--full" : "day-need--short"}`}
                                                title={selectorType === "cafe" ? "Человек распределено / нужно" : "Назначено / нужно исполнителей"}
                                            >
                                                {dayNeeds[day].assigned}/{dayNeeds[day].needed}
                                            </div>
                                        )}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {performers.map((driver) => (
                                <tr key={`${selectorType}-${driver.id}-${driver.name}`}>
                                    <td className="sticky-column performer-name">
                                        <div className="name">{driver.name}</div>
                                        {driver.car_name && (
                                            <div className="car">{driver.car_name}</div>
                                        )}
                                    </td>

                                    {days.map((day) => {
                                        const isMulti = selectorType === "sedan" || selectorType === "bus" || selectorType === "cafe";
                                        const dayTours = getAssignedToursForDay(driver.name, day);
                                        const hasCancelled = dayTours.some((t) => t.isCancelled);

                                        return (
                                            <td
                                                key={day}
                                                className={`performer-input ${dayTours.length ? "assigned" : ""} ${hasCancelled ? "cancelled" : ""}`}
                                                onClick={() => modalWindow(driver, day)}
                                            >
                                                {isMulti
                                                    ? dayTours.map((t) => {
                                                        let line = `№${t.orderNumber} — ${t.title}${paxLabel(t)}`;
                                                        if (selectorType === "cafe") {
                                                            const own = t.assignments?.find((a) => a.name === driver.name);
                                                            if (own) line += ` (${own.count})`;
                                                        }
                                                        if (t.isCancelled) line += " (отменён)";
                                                        return (
                                                            <div key={`${t.orderNumber}-${t.requestType}`} className={`cell-multi-line ${t.isCancelled ? "cancelled-line" : ""}`}>
                                                                {line}
                                                            </div>
                                                        );
                                                    })
                                                    : (() => {
                                                        const assigned = dayTours[0];
                                                        if (!assigned) return "";
                                                        let line = `№${assigned.orderNumber} — ${assigned.title}`;
                                                        if (selectorType === "guide" && assigned.guideLang) {
                                                            line += ` (${LANG_LABELS[assigned.guideLang] || assigned.guideLang})`;
                                                        }
                                                        if (assigned.isCancelled) line += " (отменён)";
                                                        return line;
                                                    })()}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {modal.open && (
                <div className="performersmodalWindow" onClick={() => setModal({ ...modal, open: false })}>
                    <div className="performersmodalWindow-block" onClick={(e) => e.stopPropagation()}>
                        <div className="performersmodalWindow-header">
                            <h2>{modal.name} — {modal.day} {modal.monthName} ({modal.weekday})</h2>
                            <button className="modal-close-x" onClick={() => setModal({ ...modal, open: false })}>✕</button>
                        </div>

                        {modal.multi ? (
                            <>
                                {modal.ongoing && modal.ongoing.length > 0 && (
                                    <div className="performersmodalWindow-info">
                                        <div className="info-row"><span>Ресурс</span><b>{modal.name}</b></div>
                                        <div className="info-row"><span>Уже в пути (нельзя изменить здесь)</span></div>
                                        {modal.ongoing.map((t) => (
                                            <div key={`${t.orderNumber}-${t.requestType}`} className="info-row">
                                                <span>№{t.orderNumber} — {t.title}</span>
                                                <b>{t.dateStart} — {t.dateEnd}</b>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div className="performersmodalWindow-info">
                                    <div className="info-row"><span>Ресурс</span><b>{modal.name}</b></div>
                                    <div className="info-row"><span>День</span><b>{modal.day} {modal.monthName} {currentDate.getFullYear()}</b></div>
                                </div>

                                <div className="performersmodalWindow-select">
                                    <label>ЗАКАЗЫ НА ЭТОТ ДЕНЬ</label>
                                    {modalTours.filter((t) => selectorType === "cafe" ? t.ownCount > 0 : t.assignedNames?.includes(modal.name)).length === 0 && (
                                        <div className="cafe-count-hint" style={{ textAlign: "center", display: "block" }}>
                                            Пока нет назначенных заказов
                                        </div>
                                    )}
                                    {modalTours
                                        .filter((t) => selectorType === "cafe" ? t.ownCount > 0 : t.assignedNames?.includes(modal.name))
                                        .map((t) => (
                                            <div key={`${t.orderNumber}-${t.requestType}`} className={`multi-order-row ${t.isCancelled ? "cancelled-row" : ""}`}>
                                                <span>
                                                №{t.orderNumber} — {t.title}{t.tour ? ` (${t.tour})` : ""}{paxLabel(t)}
                                                    {selectorType === "cafe" ? ` — ${t.ownCount} чел.` : ""}
                                                    {t.isCancelled ? " (отменён)" : ""}
                                                </span>
                                                <button
                                                    type="button"
                                                    className="multi-order-remove"
                                                    onClick={async () => {
                                                        try {
                                                            await axios.post(`${API_URL}/clearAssignment`, {
                                                                selectorType,
                                                                performerName: modal.name,
                                                                orderNumber: t.orderNumber,
                                                                requestType: t.requestType,
                                                            });
                                                            toast.success("Заказ убран");
                                                            const res = await axios.post(`${API_URL}/getCellInfo`, {
                                                                selectorType,
                                                                performerName: modal.name,
                                                                date: modal.date,
                                                            });
                                                            setModalTours(res.data.tours || []);
                                                            refreshMonthData();
                                                        } catch (err) {
                                                            console.error(err);
                                                            toast.error("Не удалось убрать заказ");
                                                        }
                                                    }}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))}
                                </div>

                                <div className="performersmodalWindow-select">
                                    <label>ДОБАВИТЬ ЕЩЁ ЗАКАЗ</label>
                                    <div className="multi-add-row">
                                        <select
                                            value={selectedTourValue}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                setSelectedTourValue(val);
                                                if (selectorType === "cafe") {
                                                    if (!val) {
                                                        setCafeCount(0);
                                                    } else {
                                                        const [on, rt] = val.split("|");
                                                        const t = modalTours.find((x) => String(x.orderNumber) === on && x.requestType === rt);
                                                        setCafeCount(t ? t.maxAvailable : 0);
                                                    }
                                                }
                                            }}
                                        >
                                            <option value="">— Выберите заказ —</option>
                                            {modalTours
                                                .filter((t) => selectorType === "cafe" ? (t.ownCount === 0 && t.maxAvailable > 0) : !t.assignedNames?.includes(modal.name))
                                                .map((t) => (
                                                    <option key={`${t.orderNumber}-${t.requestType}`} value={`${t.orderNumber}|${t.requestType}`}>
                                                        {selectorType === "cafe"
                                                            ? `№${t.orderNumber} — ${t.title}${t.tour ? ` (${t.tour})` : ""} — нужно ${t.maxAvailable} из ${t.total}`
                                                            : `№${t.orderNumber} — ${t.title}${t.tour ? ` (${t.tour})` : ""}${paxLabel(t)} (${t.assignedNames?.length}/${t.neededCount})`}
                                                    </option>
                                                ))}
                                        </select>
                                        {selectorType !== "cafe" && (
                                            <button
                                                type="button"
                                                className="multi-add-btn"
                                                disabled={!selectedTourValue}
                                                onClick={async () => {
                                                    const [orderNumber, requestType] = selectedTourValue.split("|");
                                                    try {
                                                        const res = await axios.post(`${API_URL}/assignPerformer`, {
                                                            selectorType,
                                                            performerName: modal.name,
                                                            orderNumber: Number(orderNumber),
                                                            requestType,
                                                        });
                                                        if (res.data.status === "error") {
                                                            toast.error(res.data.message || "Не удалось добавить");
                                                            return;
                                                        }
                                                        toast.success("Заказ добавлен");
                                                        setSelectedTourValue("");
                                                        const cellRes = await axios.post(`${API_URL}/getCellInfo`, {
                                                            selectorType,
                                                            performerName: modal.name,
                                                            date: modal.date,
                                                        });
                                                        setModalTours(cellRes.data.tours || []);
                                                        refreshMonthData();
                                                    } catch (err) {
                                                        console.error(err);
                                                        toast.error("Не удалось добавить заказ");
                                                    }
                                                }}
                                            >
                                                +
                                            </button>
                                        )}
                                    </div>

                                    {selectorType === "cafe" && selectedTourValue && (() => {
                                        const [on, rt] = selectedTourValue.split("|");
                                        const t = modalTours.find((x) => String(x.orderNumber) === on && x.requestType === rt);
                                        if (!t) return null;
                                        return (
                                            <div className="cafe-count-stepper" style={{ marginTop: 10 }}>
                                                <button
                                                    type="button"
                                                    className="cafe-count-btn"
                                                    onClick={() => setCafeCount((c) => Math.max(0, c - 1))}
                                                >
                                                    −
                                                </button>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    max={t.maxAvailable}
                                                    value={cafeCount}
                                                    onChange={(e) => setCafeCount(Math.min(t.maxAvailable, Math.max(0, Number(e.target.value) || 0)))}
                                                />
                                                <button
                                                    type="button"
                                                    className="cafe-count-btn"
                                                    onClick={() => setCafeCount((c) => Math.min(t.maxAvailable, c + 1))}
                                                >
                                                    +
                                                </button>
                                                <button
                                                    type="button"
                                                    className="multi-add-btn"
                                                    disabled={cafeCount <= 0}
                                                    onClick={async () => {
                                                        const [orderNumber, requestType] = selectedTourValue.split("|");
                                                        try {
                                                            const res = await axios.post(`${API_URL}/assignPerformer`, {
                                                                selectorType,
                                                                performerName: modal.name,
                                                                orderNumber: Number(orderNumber),
                                                                requestType,
                                                                count: cafeCount,
                                                            });
                                                            if (res.data.status === "error") {
                                                                toast.error(res.data.message || "Не удалось добавить");
                                                                return;
                                                            }
                                                            toast.success("Заказ добавлен");
                                                            setSelectedTourValue("");
                                                            setCafeCount(0);
                                                            const cellRes = await axios.post(`${API_URL}/getCellInfo`, {
                                                                selectorType,
                                                                performerName: modal.name,
                                                                date: modal.date,
                                                            });
                                                            setModalTours(cellRes.data.tours || []);
                                                            refreshMonthData();
                                                        } catch (err) {
                                                            console.error(err);
                                                            toast.error("Не удалось добавить заказ");
                                                        }
                                                    }}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        );
                                    })()}
                                </div>

                                <div className="performersmodalWindow-actions">
                                    <button className="btn-cancel" onClick={() => setModal({ ...modal, open: false })}>Закрыть</button>

                                </div>
                            </>
                        ) : modal.readOnly ? (
                            <>
                                <div className="performersmodalWindow-info">
                                    <div className="info-row"><span>Ресурс</span><b>{modal.name}</b></div>
                                    <div className="info-row">
                                        <span>Статус</span>
                                        <b className={modal.readOnlyInfo.isCancelled ? "status-busy" : "status-busy"}>
                                            {modal.readOnlyInfo.isCancelled ? "Тур отменён" : "Занят"}
                                        </b>
                                    </div>
                                    <div className="info-row">
                                        <span>Тур</span>
                                        <b>№{modal.readOnlyInfo.orderNumber} — {modal.readOnlyInfo.title}</b>
                                    </div>
                                    <div className="info-row">
                                        <span>Период</span>
                                        <b>{modal.readOnlyInfo.dateStart} — {modal.readOnlyInfo.dateEnd}</b>
                                    </div>
                                </div>
                                <div className="performersmodalWindow-actions">
                                    <button className="btn-cancel" style={{ flex: 1 }} onClick={() => setModal({ ...modal, open: false })}>
                                        Закрыть
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="performersmodalWindow-info">
                                    <div className="info-row"><span>Ресурс</span><b>{modal.name}</b></div>
                                    <div className="info-row"><span>День</span><b>{modal.day} {modal.monthName} {currentDate.getFullYear()}</b></div>
                                    <div className="info-row">
                                        <span>Статус</span>
                                        <b className={selectedTourValue ? "status-busy" : "status-free"}>
                                            {selectedTourValue ? "Занят" : "Свободен"}
                                        </b>
                                    </div>
                                </div>

                                <div className="performersmodalWindow-select">
                                    <label>НАЗНАЧИТЬ ТУР</label>
                                    <select
                                        value={selectedTourValue}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setSelectedTourValue(val);
                                            if (selectorType === "cafe") {
                                                if (!val) {
                                                    setCafeCount(0);
                                                } else {
                                                    const [on, rt] = val.split("|");
                                                    const t = modalTours.find((x) => String(x.orderNumber) === on && x.requestType === rt);
                                                    setCafeCount(t ? t.maxAvailable : 0);
                                                }
                                            }
                                        }}
                                    >
                                        <option value="">— Свободен —</option>
                                        {modalTours.map((t) => (
                                            <option key={`${t.orderNumber}-${t.requestType}`} value={`${t.orderNumber}|${t.requestType}`}>
                                                {selectorType === "cafe"
                                                    ? `№${t.orderNumber} — ${t.title}${t.tour ? ` (${t.tour})` : ""} — нужно ${t.maxAvailable} из ${t.total}`
                                                    : selectorType === "guide"
                                                        ? `№${t.orderNumber} — ${t.title}${t.tour ? ` (${t.tour})` : ""}${t.guideLang ? ` — ${LANG_LABELS[t.guideLang] || t.guideLang}` : ""} (${t.assignedNames?.length}/${t.neededCount})`
                                                        : `№${t.orderNumber} — ${t.title}${t.tour ? ` (${t.tour})` : ""} (${t.assignedNames?.length}/${t.neededCount})`}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                                {selectorType === "cafe" && selectedTourValue && (() => {
                                    const [on, rt] = selectedTourValue.split("|");
                                    const t = modalTours.find((x) => String(x.orderNumber) === on && x.requestType === rt);
                                    if (!t) return null;
                                    return (
                                        <div className="performersmodalWindow-select">
                                            <label>
                                                КОЛИЧЕСТВО ЧЕЛОВЕК
                                                <span className="cafe-count-hint">макс. {t.maxAvailable} из {t.total}</span>
                                            </label>
                                            <div className="cafe-count-stepper">
                                                <button
                                                    type="button"
                                                    className="cafe-count-btn"
                                                    onClick={() => setCafeCount((c) => Math.max(0, c - 1))}
                                                >
                                                    −
                                                </button>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    max={t.maxAvailable}
                                                    value={cafeCount}
                                                    onChange={(e) => setCafeCount(Math.min(t.maxAvailable, Math.max(0, Number(e.target.value) || 0)))}
                                                />
                                                <button
                                                    type="button"
                                                    className="cafe-count-btn"
                                                    onClick={() => setCafeCount((c) => Math.min(t.maxAvailable, c + 1))}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })()}
                                <div className="performersmodalWindow-actions">
                                    <button className="btn-cancel" onClick={() => setModal({ ...modal, open: false })}>Закрыть</button>
                                    <button
                                        className="btn-save"
                                        onClick={async () => {
                                            try {
                                                if (selectorType === "cafe") {
                                                    const current = modalTours.find((t) => t.ownCount > 0);

                                                    if (!selectedTourValue || cafeCount <= 0) {
                                                        if (current) {
                                                            await axios.post(`${API_URL}/clearAssignment`, {
                                                                selectorType,
                                                                performerName: modal.name,
                                                                orderNumber: current.orderNumber,
                                                                requestType: current.requestType,
                                                            });
                                                            toast.success("Назначение снято");
                                                        }
                                                        setModal({ ...modal, open: false });
                                                        refreshMonthData();
                                                        return;
                                                    }

                                                    const [orderNumber, requestType] = selectedTourValue.split("|");

                                                    if (current && (String(current.orderNumber) !== orderNumber || current.requestType !== requestType)) {
                                                        await axios.post(`${API_URL}/clearAssignment`, {
                                                            selectorType,
                                                            performerName: modal.name,
                                                            orderNumber: current.orderNumber,
                                                            requestType: current.requestType,
                                                        });
                                                    }

                                                    const res = await axios.post(`${API_URL}/assignPerformer`, {
                                                        selectorType,
                                                        performerName: modal.name,
                                                        orderNumber: Number(orderNumber),
                                                        requestType,
                                                        count: cafeCount,
                                                    });

                                                    if (res.data.status === "error") {
                                                        toast.error(res.data.message || "Не удалось назначить");
                                                        return;
                                                    }

                                                    toast.success("Назначено");
                                                    setModal({ ...modal, open: false });
                                                    refreshMonthData();
                                                    return;
                                                }

                                                // ── 4x4 / sedan / bus / guide ──
                                                const current = modalTours.find((t) => t.assignedNames?.includes(modal.name));

                                                if (!selectedTourValue) {
                                                    if (current) {
                                                        await axios.post(`${API_URL}/clearAssignment`, {
                                                            selectorType,
                                                            performerName: modal.name,
                                                            orderNumber: current.orderNumber,
                                                            requestType: current.requestType,
                                                        });
                                                        toast.success("Назначение снято");
                                                    }
                                                    setModal({ ...modal, open: false });
                                                    refreshMonthData();
                                                    return;
                                                }

                                                const [orderNumber, requestType] = selectedTourValue.split("|");

                                                if (current && (String(current.orderNumber) !== orderNumber || current.requestType !== requestType)) {
                                                    await axios.post(`${API_URL}/clearAssignment`, {
                                                        selectorType,
                                                        performerName: modal.name,
                                                        orderNumber: current.orderNumber,
                                                        requestType: current.requestType,
                                                    });
                                                }

                                                const res = await axios.post(`${API_URL}/assignPerformer`, {
                                                    selectorType,
                                                    performerName: modal.name,
                                                    orderNumber: Number(orderNumber),
                                                    requestType,
                                                });

                                                if (res.data.status === "error") {
                                                    toast.error(res.data.message || "Не удалось назначить");
                                                    return;
                                                }

                                                toast.success("Назначено");
                                                setModal({ ...modal, open: false });
                                                refreshMonthData();
                                            } catch (err) {
                                                console.error(err);
                                                toast.error("Не удалось сохранить");
                                            }
                                        }}
                                    >Сохранить</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div >
    );
};

export default Performers;